export default "| **S-7** | A dropped connection picks itself back up, without a reload | #1306 | Oct 29 |\n"